import { useUsersApi } from "@/Hooks/useUsersApi";

export function useAuthenticationRequestResetPassword() {
  const usersApi = useUsersApi();
  async function requestReset(email: string): Promise<boolean> {
    try {
      await usersApi.requestPasswordReset({
        requestPasswordResetRequest: {
          email,
        },
      });
      return true;
    } catch (e) {
      console.error("Something went wrong requesting a password reset", {
        e,
      });
      return false;
    }
  }

  return { requestReset };
}
